import React from "react";
import "./LoginPage.scss";
import gif from "./gif.gif";

function LoginPage() {
  return (
    <div className="loginPage">
      <img src={gif} alt="under construction" />
    </div>
  );
}

export default LoginPage;
